module.exports = __webpack_public_path__ + "assets/img/33@3x.104bcbd5.png";